module.exports = __webpack_public_path__ + "img/5-5.e3a22ff5.png";